<div class="title">SIGN UP WITH XERO</div>

<div class="margin-top-48" *ngIf="isPageLoading" style="display:flex; justify-content: center; align-items: center;">
    <div class="spinner-container">
        <div class="spinner-border" role="status"></div>
    </div>
</div>

<div *ngIf="!isPageLoading && !isLoginWithXero">
    <div *ngIf="isSignupSuccess">
        <!--xero signup success-->
        <div class="sub-title">
            Email Verification Required
        </div>
        <div class="margin-top-48">
            <div>
                Please check your email <span class="highlight">{{isSignupSuccessMessage_Email}}</span> for 
                verification to continue activating your HUBTIGER 
                account for <span class="highlight">{{isSignupSuccessMessage_Name}}</span>.
            </div>
        </div>
        <!--xero signup success-->
    </div>

    <div *ngIf="!isSignupSuccess">
        <!--xero signup error-->
        <div class="margin-top-48">
            <div>
                {{ isSignupErrorMessage }}
            </div>

            <div class="error" *ngIf="error">
                <span>{{errorMessage}}</span>
            </div>

            <button type="button" class="btn btn-primary" [disabled]="isLoading" (click)="tryAgain()"
                style="margin-top:0;">
                <i class="fa fa-spin fa-spinner" *ngIf="isLoading"></i>
                <span *ngIf="!isLoading">Try Again</span>
            </button>
        </div>
        <!--xero signup error-->
    </div>
</div>

<div *ngIf="!isPageLoading && isLoginWithXero && hasLoginToken">
    <!--xero login success-->
    <div class="sub-title">
        Busy signing you in, please wait...
    </div>
    <div class="margin-top-48" style="display:flex; justify-content: center; align-items: center;">
        <div class="spinner-container">
            <div class="spinner-border" role="status"></div>
        </div>
    </div>
    <!--xero login success-->
</div>

<div *ngIf="!isPageLoading && isLoginWithXero && !hasLoginToken">
    <!--xero login success - no token -->
    <div class="sub-title">
        Sign in with your HUBTIGER account
    </div>
    <div class="margin-top-48" style="display:flex; justify-content: center; align-items: center;">
        <button type="button" class="btn btn-primary" (click)="signInHubtiger()" [disabled]="isLoading" style="margin-top:0;">
            <i class="fa fa-spin fa-spinner" *ngIf="isLoading"></i>
            <span *ngIf="!isLoading">Sign in with Hubtiger</span>
        </button>
    </div>
    <!--xero login success - no token-->
</div>